import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import classNames from 'classnames'

import { Store } from '../../../reducers/index'
import {
  EditableCase,
  getEditableCases,
  getSelectedCaseId,
  getSelectedItemId,
  getValidCategories
} from '../../../reducers/project'
import {
  selectCaseItem,
  changeCase,
  deleteCase
} from '../../../actions/project'
import { Action } from '../../../actions/types'
import { CaseButton, CaseList } from './InputCategoryStyles'
import InputCase from './InputCase'
import Delete from 'material-ui/svg-icons/action/delete'
import themeObj from '../../../theme/defaultTheme'
import { recordEvent } from '../../../analytics'

const ArrowImg = require('../../Shared/arrow_right.svg')

type Props = {
  cases: EditableCase[]
  activeCaseId: string | null
  activeItemId: string | null
  validCategories: string[]
  selectItem: (itemId: string) => Action
  selectCase: (caseId: string) => Action
  deleteCase: (caseId: string) => Action
}

type State = {}

class InputCaseContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.selectCase = this.selectCase.bind(this)
  }

  selectCase(caseId: string) {
    if (this.props.activeCaseId !== caseId) {
      this.props.selectCase(caseId)
    }
  }

  removeCase(e: React.SyntheticEvent<{}>, kase: EditableCase) {
    e.preventDefault()
    if (window.confirm(`Deleting case ${kase.name}, are you sure?`)) {
      recordEvent('workspace', 'case-deleted')
      this.props.deleteCase(kase.id)
    }
  }

  render() {
    const single = this.props.cases.length === 1
    const active = this.props.activeCaseId
    return (
      <CaseList id="workspace-case-list">
        {this.props.cases.map(kase => (
          <li key={kase.id} className={active === kase.id ? 'active' : ''}>
            <CaseButton
              className={classNames({
                open: active === kase.id,
                closed: active !== kase.id,
                single
              })}
            >
              <button
                disabled={single}
                className="main"
                onClick={() => this.selectCase(kase.id)}
              >
                <img src={ArrowImg} />
                <span className="case-button-label">{kase.name}</span>
              </button>
              {this.props.cases.length > 1 && (
                <button
                  className="delete hover-right-action"
                  onClick={e => this.removeCase(e, kase)}
                >
                  <Delete color={themeObj.colors.light} />
                </button>
              )}
            </CaseButton>
            {active === kase.id && <InputCase />}
          </li>
        ))}
      </CaseList>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  cases: getEditableCases(state),
  activeCaseId: getSelectedCaseId(state),
  activeItemId: getSelectedItemId(state),
  validCategories: getValidCategories(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  selectItem: (itemId: string) => dispatch(selectCaseItem(itemId)),
  selectCase: (caseId: string) => dispatch(changeCase(caseId)),
  deleteCase: (caseId: string) => dispatch(deleteCase(caseId))
})

export default connect(mapStateToProps, mapDispatchToProps)(InputCaseContainer)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/InputCaseContainer.tsx